import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './StudentProjectsSection.css';

const flagshipCardsList = [
  {
    id: 'subscription',
    tag: 'BACKED BY CORE2WEB 2025',
    title: 'The Subscription',
    domain: 'thesubscription.in',
    url: 'https://thesubscription.in/',
    desc: 'Shashi Sir and Core2Web actively back and mentor students to build real, revenue-generating tech startups and production SaaS platforms. <strong>The Subscription</strong> is an enterprise SaaS platform engineered by Core2Web developers and incubated under <strong>Core2Web Systems</strong>.',
    highlights: [
      'Live Enterprise SaaS Application',
      'Architected & Built by Core2Web Student Squads',
      '100% Backed by Core2Web'
    ],
    btnText: 'Know more about thesubscription.in',
    image: '/assets/full%20stack/sir-ranjeet.jpeg',
    founder: 'Ranjeet Bhosale',
    founderRole: 'FOUNDER',
    cofounder: 'Shashi Sir',
    cofounderRole: 'CO-FOUNDER',
    caption: 'Backed by Core2web'
  },
  /*
  {
    id: 'playz',
    tag: 'BACKED BY CORE2WEB 2026',
    title: 'playZ',
    domain: 'playz.in',
    url: 'https://playz.in/',
    desc: 'Next-gen sports venue booking & turf management SaaS platform engineered by Core2Web developers and incubated under <strong>Core2Web Systems</strong>. <strong>playZ</strong> allows players to discover turfs, book slots instantly, and build local sports communities.',
    highlights: [
      'Real-Time Sports & Turf Slot Booking Engine',
      'Architected & Built by Core2Web Student Squads',
      '100% Backed by Core2Web'
    ],
    btnText: 'Visit live website at playz.in',
    image: '/assets/full%20stack/sir-ranjeet.jpeg',
    founder: 'Core2Web Squad',
    founderRole: 'ENGINEERS',
    cofounder: 'Shashi Sir',
    cofounderRole: 'CO-FOUNDER',
    caption: 'Incubated at Core2web'
  }
  */
];

const studentProjectsList = [
  {
    id: 'bite-cw',
    title: 'Bite.c2w Food Delivery',
    domain: 'bite.core2web.in',
    url: '#',
    badge: 'STUDENT ENTERPRISE PROJECT',
    desc: 'Comprehensive full-stack food delivery ecosystem with live restaurant menu discovery, cart state management, and real-time order tracking.',
    tech: ['HTML5', 'CSS3', 'JavaScript', 'Spring Boot'],
    features: [
      'Interactive restaurant listings & search',
      'Dish customization & cart drawer UI',
      'Live order tracking timeline component'
    ]
  },
  {
    id: 'eventpass',
    title: 'EventPass Booking App',
    domain: 'eventpass.core2web.in',
    url: '#',
    badge: 'STUDENT ENTERPRISE PROJECT',
    desc: 'Event pass discovery & ticketing platform featuring pass tier selection, digital QR ticket generation, and active pass wallet dashboard.',
    tech: ['React.js', 'Spring Boot', 'MySQL', 'QR Engine'],
    features: [
      'VIP vs Standard pass selection modal',
      'Dynamic QR code pass generation',
      'Personal digital ticket wallet dashboard'
    ]
  },
  {
    id: 'taskflow',
    title: 'TaskFlow Productivity SaaS',
    domain: 'taskflow.core2web.in',
    url: '#',
    badge: 'STUDENT MAJOR PROJECT',
    desc: 'Productivity task manager with status filters, priority level badges, REST API backend sync, and persistent MySQL storage.',
    tech: ['React.js', 'Spring Boot', 'MySQL', 'REST API'],
    features: [
      'Task status toggles & priority color badges',
      'Full CRUD operations with Spring Boot JPA',
      'Persistent database task management'
    ]
  }
];

const StudentProjectsSection = () => {
  const [flagshipIdx, setFlagshipIdx] = useState(0);
  const [isHovering, setIsHovering] = useState(false);

  useEffect(() => {
    if (isHovering) return;
    const timer = setInterval(() => {
      setFlagshipIdx((prev) => (prev + 1) % flagshipCardsList.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [isHovering]);

  const handleNext = () => {
    setFlagshipIdx((prev) => (prev + 1) % flagshipCardsList.length);
  };

  const handlePrev = () => {
    setFlagshipIdx((prev) => (prev - 1 + flagshipCardsList.length) % flagshipCardsList.length);
  };

  return (
    <section className="ucp-section student-projects-section" id="student-projects">
      <div className="projects-container">
        {/* Section Header */}
        <motion.div
          className="projects-header"
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <div className="projects-badge">
            <span className="material-symbols-outlined">rocket_launch</span>
            REAL PRODUCTION PROJECTS
          </div>
          <h2>
            Ideas Turn Into a <span className="blue-text">Statups</span>
          </h2>
          <p className="projects-subtitle">
            Our students don't just solve dummy assignments — they engineer real-world enterprise applications backed and incubated by <strong>Core2Web</strong>.
          </p>
        </motion.div>

        {/* Featured Flagship Product Banner Carousel: The Subscription & playZ */}
        <div
          className="flagship-carousel-container"
          onMouseEnter={() => setIsHovering(true)}
          onMouseLeave={() => setIsHovering(false)}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={flagshipCardsList[flagshipIdx].id}
              className="flagship-card-hero"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.35 }}
            >
              <div className="flagship-left">
                <div className="flagship-top-tag">
                  <span className="pulse-emerald"></span>
                  {flagshipCardsList[flagshipIdx].tag}
                </div>

                <h3 className="flagship-title">
                  {flagshipCardsList[flagshipIdx].title} <span className="flagship-url-pill">{flagshipCardsList[flagshipIdx].domain}</span>
                </h3>

                <p
                  className="flagship-desc"
                  dangerouslySetInnerHTML={{ __html: flagshipCardsList[flagshipIdx].desc }}
                />

                <div className="flagship-highlights-list">
                  {flagshipCardsList[flagshipIdx].highlights.map((h, i) => (
                    <div key={i} className="highlight-item">
                      <span className="material-symbols-outlined check-icon">check_circle</span>
                      <span>{h}</span>
                    </div>
                  ))}
                </div>

                <div className="flagship-actions">
                  <a
                    href={flagshipCardsList[flagshipIdx].url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-visit-live"
                  >
                    <span>{flagshipCardsList[flagshipIdx].btnText}</span>
                    <span className="material-symbols-outlined icon-arrow">open_in_new</span>
                  </a>
                </div>
              </div>

              <div className="flagship-right">
                <div className="fsp-sub-image-card">
                  <img
                    src={flagshipCardsList[flagshipIdx].image}
                    alt={`${flagshipCardsList[flagshipIdx].title} - Core2Web Incubated Product`}
                    className="fsp-sub-showcase-img"
                  />
                  <div className="fsp-sub-img-caption-bar">
                    <div className="fsp-sub-founders-row">
                      <div className="fsp-founder-tag">
                        <span className="pulse-emerald"></span>
                        <strong>{flagshipCardsList[flagshipIdx].founder}</strong>
                        <span className="role-badge">{flagshipCardsList[flagshipIdx].founderRole}</span>
                      </div>
                      <div className="fsp-founder-tag">
                        <span className="material-symbols-outlined" style={{ fontSize: '15px', color: '#feef00' }}>verified</span>
                        <strong>{flagshipCardsList[flagshipIdx].cofounder}</strong>
                        <span className="role-badge">{flagshipCardsList[flagshipIdx].cofounderRole}</span>
                      </div>
                    </div>
                    <span className="fsp-sub-img-title">{flagshipCardsList[flagshipIdx].caption}</span>
                  </div>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          {/* Carousel Controls: Navigation Arrows & Slide Dots */}
          {flagshipCardsList.length > 1 && (
            <div className="flagship-carousel-controls">
              <button
                type="button"
                onClick={handlePrev}
                className="flagship-arrow-btn"
                aria-label="Previous Slide"
              >
                <span className="material-symbols-outlined">chevron_left</span>
              </button>

              <div className="flagship-dots-row">
                {flagshipCardsList.map((card, index) => (
                  <button
                    key={card.id}
                    type="button"
                    onClick={() => setFlagshipIdx(index)}
                    className={`flagship-dot-pill ${flagshipIdx === index ? 'active' : ''}`}
                  >
                    <span>{card.title}</span>
                  </button>
                ))}
              </div>

              <button
                type="button"
                onClick={handleNext}
                className="flagship-arrow-btn"
                aria-label="Next Slide"
              >
                <span className="material-symbols-outlined">chevron_right</span>
              </button>
            </div>
          )}
        </div>

        {/* Other Student Enterprise Projects Grid */}
        <div className="student-grid-header">
          <h3>More Student Built Projects</h3>
          <p>Real hands-on web applications created during the course.</p>
        </div>

        <div className="projects-grid">
          {studentProjectsList.slice(1).map((proj) => (
            <motion.div
              key={proj.id}
              className="student-project-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              whileHover={{ y: -6 }}
            >
              <div className="card-top">
                <span className="project-badge">{proj.badge}</span>
                <h4 className="project-title">{proj.title}</h4>
                <p className="project-desc">{proj.desc}</p>
              </div>

              <div className="card-tech-flex">
                {proj.tech.map((t, idx) => (
                  <span key={idx} className="mini-tech-pill">{t}</span>
                ))}
              </div>

              <div className="card-features">
                {proj.features.map((f, idx) => (
                  <div key={idx} className="feature-row">
                    <span className="material-symbols-outlined check-dot">check_small</span>
                    <span>{f}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StudentProjectsSection;
